import { getCreditAtom, resetCreditSelectedTabAtom, setCreditSelectedTabAtom } from "@/store/credit/credit.actions";
import { creditAtom, creditSelectedTabAtom, errorAtom, isLoadingAtom } from "@/store/credit/credit.atoms";
import { useAtomValue, useSetAtom } from "jotai";

export function useCredit() {
  const credit = useAtomValue(creditAtom);
  const isLoading = useAtomValue(isLoadingAtom);
  const error = useAtomValue(errorAtom);
  const selectedTab = useAtomValue(creditSelectedTabAtom);
  const getCredit = useSetAtom(getCreditAtom);
  const setSelectedTab = useSetAtom(setCreditSelectedTabAtom);
  const resetSelectedTab = useSetAtom(resetCreditSelectedTabAtom);

  return { credit, getCredit, isLoading, error, selectedTab, setSelectedTab, resetSelectedTab };
}
